import { FormEvent, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { ApiError } from '../lib/api';
import { Alert, Button, Field, Input, Wordmark } from '../components/ui';

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const { acceptInvite } = useAuth();
  const navigate = useNavigate();

  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await acceptInvite({ token, password, fullName: fullName.trim() || undefined });
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not accept the invite.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-full place-items-center p-6">
      <div className="w-full max-w-sm">
        <Wordmark className="mb-8" />
        <h2 className="h-display text-3xl text-soft">Join your team</h2>
        <p className="mt-1 text-sm text-muted">Set a password to accept your invite.</p>

        {!token && <div className="mt-6"><Alert>This invite link is missing its token.</Alert></div>}

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <Field label="Your name">
            <Input value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Your name" autoComplete="name" />
          </Field>
          <Field label="Password" hint="At least 8 characters.">
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="new-password"
            />
          </Field>
          {error && <Alert>{error}</Alert>}
          <Button type="submit" loading={busy} disabled={!token} className="w-full">
            Accept invite
          </Button>
        </form>
      </div>
    </div>
  );
}
